export function sliders() {
  
  $('.slider').slick({
		dots: true,
		arrows: false,
		//infinite: false,
		rows: 0,
		autoplay: true,
		speed: 1000,
		autoplaySpeed: 10000,
		slidesToShow: 3,
		slidesToScroll: 3,
		customPaging: function (slider, i) {
			return '<a href="#"></a>'
		},
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

  const menuSliderOne = {
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    customPaging : function(slider, i) {
      return '';
    },
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 10000,
        settings: "unslick"
      },
      {
        breakpoint: 1600,
        settings: "slick"
      },
    ]
  };

  $('.menu-slider-one').slick(menuSliderOne);

  const menuSliderTwo = {
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging : function(slider, i) {
      return '';
    },
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 10000,
        settings: "unslick"
      },
      {
        breakpoint: 1600,
        settings: "slick"
      },
    ]
  };

  $('.menu-slider-two').slick(menuSliderTwo);
  
  const menuSliderThird = {
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    customPaging : function(slider, i) {
      return '';
    },
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 10000,
        settings: "unslick"
      },
      {
        breakpoint: 1600,
        settings: "slick"
      },
    ]
  }

  $('.menu-slider-third').slick(menuSliderThird);

  window.addEventListener('resize', function(event) {
   
      $('.menu-slider-one').slick(menuSliderOne);
      $('.menu-slider-two').slick(menuSliderTwo);
      $('.menu-slider-third').slick(menuSliderThird);
   
  }, true);

  
  $('.video-album-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    rows: 0,
    autoplay: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging : function(slider, i) {
      return '<a href="#"></a>';
    },
    lazyLoad: 'ondemand',
    prevArrow: '<div class="slick-prev"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.81355 0.172336C5.69243 0.0595264 5.52669 0.000152546 5.36733 0.000152532C5.20797 0.000152518 5.04223 0.0595264 4.92112 0.172336L0.184863 4.58379C0.0637474 4.6966 9.2211e-07 4.84504 9.08776e-07 4.99941C8.95442e-07 5.15378 0.0637473 5.30222 0.184863 5.41503L4.92112 9.82648C5.16972 10.058 5.56494 10.058 5.81355 9.82648C6.06215 9.59493 6.06215 9.22681 5.81355 8.99525L1.52351 4.99941L5.81355 1.00357C6.05578 0.772009 6.05578 0.397956 5.81355 0.172336Z" fill="#ecc055"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.186454 9.82797C0.30757 9.94078 0.473307 10.0002 0.632669 10.0002C0.792032 10.0002 0.957769 9.94078 1.07888 9.82797L5.81514 5.41651C5.93625 5.3037 6 5.15527 6 5.0009C6 4.84652 5.93625 4.69809 5.81514 4.58528L1.07888 0.17382C0.830279 -0.0577367 0.43506 -0.0577367 0.186454 0.17382C-0.0621514 0.405377 -0.0621514 0.773494 0.186454 1.00505L4.47649 5.0009L0.186454 8.99674C-0.0557769 9.2283 -0.0557769 9.60235 0.186454 9.82797Z" fill="#ecc055"/></svg></div>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          dots: true,
          arrows: false,
        }
      },
    ]
  });
  
  $('.video-album-slider-nav .video-wrapper').click(function(e) {
    
    //$(this).closest('.popup-inner').find('.video-album-slider .slick-slide video').get(0).pause();
      
    $(this).closest('.popup-inner').find('.video-album-slider').slick('slickGoTo', $(this).data('index') - 1);
    
    //$(this).closest('.popup-inner').find('.video-album-slider .slick-current video').get(0).play();
    
  });
  
  
  $('.photo-album-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    rows: 0,
    autoplay: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging : function(slider, i) {
      return '<a href="#"></a>';
    },
    lazyLoad: 'ondemand',
    prevArrow: '<div class="slick-prev"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.81355 0.172336C5.69243 0.0595264 5.52669 0.000152546 5.36733 0.000152532C5.20797 0.000152518 5.04223 0.0595264 4.92112 0.172336L0.184863 4.58379C0.0637474 4.6966 9.2211e-07 4.84504 9.08776e-07 4.99941C8.95442e-07 5.15378 0.0637473 5.30222 0.184863 5.41503L4.92112 9.82648C5.16972 10.058 5.56494 10.058 5.81355 9.82648C6.06215 9.59493 6.06215 9.22681 5.81355 8.99525L1.52351 4.99941L5.81355 1.00357C6.05578 0.772009 6.05578 0.397956 5.81355 0.172336Z" fill="#ecc055"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.186454 9.82797C0.30757 9.94078 0.473307 10.0002 0.632669 10.0002C0.792032 10.0002 0.957769 9.94078 1.07888 9.82797L5.81514 5.41651C5.93625 5.3037 6 5.15527 6 5.0009C6 4.84652 5.93625 4.69809 5.81514 4.58528L1.07888 0.17382C0.830279 -0.0577367 0.43506 -0.0577367 0.186454 0.17382C-0.0621514 0.405377 -0.0621514 0.773494 0.186454 1.00505L4.47649 5.0009L0.186454 8.99674C-0.0557769 9.2283 -0.0557769 9.60235 0.186454 9.82797Z" fill="#ecc055"/></svg></div>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          dots: true,
          arrows: false,
        }
      },
    ]
  });
  
}


// WEBPACK FOOTER //
// ./assets/js/modules/sliders.js